module.exports = __webpack_public_path__ + "media/fonts/material-design-icons/materialdesignicons-webfont-e80dbad8d3aaf07f9263f69e7963c610.woff2";